export function BottomNav({ items, active, onChange }) {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30" data-testid="bottom-nav">
      <div className="mx-auto max-w-md border-t border-[#E2E8F0] bg-white/95 px-2 pb-[max(env(safe-area-inset-bottom),0.4rem)] pt-1 backdrop-blur-xl">
        <div className="grid grid-cols-4">
          {items.map((it) => {
            const on = active === it.key;
            const Icon = it.icon;
            return (
              <button
                key={it.key}
                data-testid={`nav-${it.key}`}
                onClick={() => onChange(it.key)}
                className="relative flex flex-col items-center gap-1 py-2 outline-none"
                aria-label={it.label}
              >
                {on && <span className="absolute top-0 h-[3px] w-8 rounded-full bg-[#C5A059]" />}
                <Icon size={23} weight={on ? "fill" : "regular"} color={on ? "#0A1128" : "#94A3B8"} />
                <span className={`text-[11px] leading-none ${on ? "font-semibold text-[#0A1128]" : "text-[#94A3B8]"}`}>{it.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
